export default __webpack_public_path__ + "static/media/ic_pause_circle_outline_24px.d964397b.svg";